import { FaUserCircle } from "react-icons/fa"; 
import React, { useState, useEffect } from "react";
import { Badge, Tooltip } from "antd";
import { FcMissedCall } from "react-icons/fc";
import { MdMissedVideoCall } from "react-icons/md";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { useSignalR } from "./SignalRContext/signalRContext";

const TwilloMissedCallNotification = () => {
  const { connection } = useSignalR();
  const [missedNotifications, setMissedNotifications] = useState([]);
  const loggedInEmailId = localStorage.getItem("emailid");
  
  const RequestType = {
    LiveChat: 0,
    Audio: 1,
    Video: 2,
    Email: 3,
    Whatsapp: 4,
    SMS: 5
  };

  useEffect(() => {
    if (!connection || !loggedInEmailId) return;

    // Fetch missed notifications from the backend
    connection.invoke("GetAllMissedNotification", loggedInEmailId)
      .catch(err => console.error("Error fetching missed notifications:", err));

    // Listener for initial missed notifications
    const handleMissedNotifications = (notifications) => {
      console.log("Received Missed Notifications:", notifications);
      setMissedNotifications(notifications);
    };

    // Listener for new incoming notifications
    const handleNewNotification = (newNotification) => {
      console.log("New Notification Received:", newNotification);
      setMissedNotifications((prev) => [newNotification, ...prev]);
    };

    // Listener for clearing notifications
    const handleNotificationsCleared = (userId) => {
      console.log("Cleared Notifications:", userId);
      console.log(`Received MarkAReadToAll event for user: ${userId}`);
      if (userId === loggedInEmailId) {
        setMissedNotifications([]); // Ensure only the correct user clears notifications
      }
    };

    // Register SignalR event listeners
    connection.on("MissedNotifications", handleMissedNotifications);
    connection.on("NewNotification", handleNewNotification);
    connection.on("MarkAReadToAll", handleNotificationsCleared);

    return () => {
      // Cleanup listeners on unmount
      connection.off("MissedNotifications", handleMissedNotifications);
      connection.off("NewNotification", handleNewNotification);
      connection.off("MarkAReadToAll", handleNotificationsCleared);
    };
  }, [connection, loggedInEmailId]);

  // Function to mark all notifications as read
  const markAllAsRead = async () => {
    if (!connection || missedNotifications.length === 0) return;

    try {
      console.log("Marking all as read...");
      await connection.invoke("MarkAReadToAll", loggedInEmailId);
      console.log("All notifications marked as read");
    } catch (err) {
      console.error("Error clearing missed notifications:", err);
    }
  };

  const formatCallTime = (isoString) => {
    const callDate = new Date(isoString);
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    const today = new Date(now);
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);

    if (callDate >= today) {
        return callDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
    } else if (callDate >= yesterday) {
        return "Yesterday";
    } else {
        return callDate.toLocaleDateString();
    }
  };

  const returnCalType = (type) => {
    switch (type) {
      case RequestType.LiveChat:
      case RequestType.Audio:
        return <FcMissedCall size={20} className="ms-3 text-danger" />;
      case RequestType.Video:
        return <MdMissedVideoCall size={20} className="ms-3 text-danger" />;
      default:
        return <IoCheckmarkDoneCircleOutline size={20} className="ms-3 text-danger" />;
    }
  };

  return missedNotifications.length > 0 ? (
    <Tooltip
      overlayStyle={{ minWidth: "300px" }}
      overlayClassName="missedcall-notification-tooltip mx-5"
      overlayInnerClassName="w-100"
      trigger="hover"
      placement="bottomRight"
      color="#343A40"
      title={
        <div className="card shadow-none">
          <div className="d-flex justify-content-between align-items-center p-2">
            <h5 className="mb-0 text-light">Missed Calls</h5>
          </div>
  
          <div className="card-body w-100 p-3">
            <ul
              className="list-group list-group-flush mb-3 overflow-auto border-0 custom-scroll"
              style={{ maxHeight: "15rem" }}
            >
              {missedNotifications
                .sort((a, b) => new Date(b.callingDate) - new Date(a.callingDate))
                .map((item, index) => (
                  <li
                    key={index}
                    className="list-group-item d-flex align-items-center p-2 rounded cursor-pointer bg-transparent text-light"
                  >
                    <div
                      className="d-flex justify-content-center align-items-center text-white fw-bold rounded-circle me-3 avatar"
                    >
                      <FaUserCircle size={32} color="#585858" />

                    </div>
  
                    <div className="flex-grow-1 mx-3">
                      <p className="mb-0 fw-medium text-light">TEKaVerse</p>
                      <p className="mb-0 text-secondary" style={{ lineHeight: "1.4" }}>
                        {formatCallTime(item.callingDate)}
                      </p>
                    </div>
                    {returnCalType(item.callType)}
                  </li>
                ))}
            </ul>
  
            {/* Clear All Button */}
            <div className="d-flex justify-content-end position-sticky bottom-0">
              <button
                type="button"
                onClick={markAllAsRead}
                className="btn btn-success btn-sm shadow-sm w-100 mb-2 fw-bold d-flex align-items-center justify-content-center gap-2 rounded-pill btn-clear-all"
              >
                Clear All{" "}
                <IoCheckmarkDoneCircleOutline size={18} className="fw-bold" />
              </button>
            </div>
          </div>
        </div>
      }
    >
      <li className="list-unstyled" style={{ cursor: "pointer" }}>
        <div className="bg-light px-2 rounded py-1 d-inline-block">
          <Badge count={missedNotifications.length} offset={[5, 5]} size="small">
            <span className="position-relative d-inline-block mx-1">
              <FcMissedCall size={25} />
            </span>
          </Badge>
        </div>
      </li>
    </Tooltip>
  ) : null;
  
};

export default TwilloMissedCallNotification;
